import styled from '@emotion/styled';

export const Container = styled.div`
    width: 100%;
    padding: ${({ theme }) => theme.spacing[4]};
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
    margin-top: ${({ theme }) => theme.spacing[2]};
`;

export const FormGridTwoCols = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    gap: ${({ theme }) => theme.spacing[3]};

    ${({ theme }) => theme.breakpoints.mobile} {
        grid-template-columns: 1fr;
    }
`;

export const FormGridThreeCols = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    gap: ${({ theme }) => theme.spacing[3]};

    ${({ theme }) => theme.breakpoints.mobile} {
        grid-template-columns: 1fr;
    }
`;

export const EwalletInputWrapper = styled.div`
    max-width: 300px;
`;

export const DangerSection = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #fdf2f2;
    border: 1px dashed #e8b4b4;
    border-radius: ${({ theme }) => theme.radius.main};
    padding: 20px;
`;

export const DangerTitle = styled.h2`
    font-size: ${({ theme }) => theme.font.size.large};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: #6b1a1a;
    margin: 0 0 ${({ theme }) => theme.spacing[2]};
`;

export const DeleteContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const DateText = styled.span`
    font-size: ${({ theme }) => theme.font.size.normal};
    color: ${({ theme }) => theme.color.black400};
`;

export const DangerButton = styled.button`
    padding: 8px 16px;
    border: 1px solid #d4a0a0;
    border-radius: ${({ theme }) => theme.radius.main};
    background: transparent;
    color: #b85c5c;
    font-size: ${({ theme }) => theme.font.size.normal};
    cursor: pointer;

    &:hover {
        background: #f5e0e0;
    }
`;

export const ErrorText = styled.p`
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.bloodyMary};
    margin: 0;
`;

export const AddressFieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SectionActions = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
    margin-top: ${({ theme }) => theme.spacing[3]};
    padding-top: ${({ theme }) => theme.spacing[3]};
    border-top: 1px solid ${({ theme }) => theme.color.grey200};
`;

export const ChangesInfo = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.black200};
    margin-right: auto;
`;
